import { User } from '../models/user';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AuthRepo {
  user: User;

  async setUser(user: User) {
    this.user = user;
    await localStorage.setItem('user', JSON.stringify(user));
  }

  async loadUser() {
    const ret = await localStorage.getItem('user');
    if (ret) {
      const user = JSON.parse(ret);
      this.user = new User(user);
      return this.user;
    }
    return null;
  }

  async removeUser() {
    this.user = null;
    await localStorage.removeItem('user');
  }

  async clear() {
    await localStorage.clear();
  }

  public getUser() {
    return this.user;
  }
}
